import React, { useState, useEffect, useCallback } from "react";
import Col from "react-bootstrap/Col";
import Skeleton from "react-loading-skeleton";
import axios from "axios";

const ProjectCard = ({ value }) => {
  const { name, description, svn_url, stargazers_count, languages_url, pushed_at } = value;

  return (
    <Col md={6} lg={4} className="mb-4">
      <div className="project-card">
        <div className="project-card-header">
          <i className="fab fa-github project-card-icon" />
          <h5 className="project-card-name">{name || <Skeleton width={120} />}</h5>
        </div>

        <p className="project-card-desc">
          {name === null ? <Skeleton count={2} /> : (description || "No description provided.")}
        </p>

        {languages_url ? (
          <Language languages_url={languages_url} repo_url={svn_url} />
        ) : (
          <Skeleton count={1} />
        )}

        <div className="project-card-footer">
          {pushed_at ? (
            <UpdatedAt pushed_at={pushed_at} star_count={stargazers_count} repo_url={svn_url} />
          ) : (
            <Skeleton width={100} />
          )}

          {svn_url && (
            <a
              href={svn_url}
              target="_blank"
              rel="noopener noreferrer"
              className="project-card-link"
            >
              View Repo →
            </a>
          )}
        </div>
      </div>
    </Col>
  );
};

const Language = ({ languages_url, repo_url }) => {
  const [data, setData] = useState([]);

  const handleRequest = useCallback(async () => {
    try {
      const response = await axios.get(languages_url);
      setData(response.data);
    } catch (error) {
      console.error(error.message);
    }
  }, [languages_url]);

  useEffect(() => {
    handleRequest();
  }, [handleRequest]);

  const entries = Object.entries(data);
  const total = entries.reduce((sum, [, v]) => sum + v, 0);

  if (!entries.length) return <p className="project-no-lang">No languages detected</p>;

  return (
    <div className="project-lang-tags">
      {entries.map(([lang, count]) => (
        <a
          key={lang}
          href={`${repo_url}/search?l=${lang}`}
          target="_blank"
          rel="noopener noreferrer"
          className="project-lang-tag"
        >
          {lang} · {Math.trunc((count / total) * 1000) / 10}%
        </a>
      ))}
    </div>
  );
};

const UpdatedAt = ({ pushed_at, star_count, repo_url }) => {
  const [updated_at, setUpdated_at] = useState("");

  useEffect(() => {
    const date = new Date(pushed_at);
    const hours = Math.trunc((Date.now() - date.getTime()) / 3600000);
    if (hours < 1) setUpdated_at("just now");
    else if (hours < 24) setUpdated_at(`${hours}h ago`);
    else {
      setUpdated_at(new Intl.DateTimeFormat("en-US", { day: "numeric", month: "short", year: "numeric" }).format(date));
    }
  }, [pushed_at]);

  return (
    <span className="project-meta">
      <a href={`${repo_url}/stargazers`} target="_blank" rel="noopener noreferrer" className="project-stars">
        <i className="fas fa-star" /> {star_count}
      </a>
      <span className="project-updated">· {updated_at}</span>
    </span>
  );
};

export default ProjectCard;
